// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file types/v1/date.proto (package types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file types/v1/date.proto.
 */
export const file_types_v1_date: GenFile = /*@__PURE__*/
  fileDesc("ChN0eXBlcy92MS9kYXRlLnByb3RvEgh0eXBlcy52MSKtAQoKRGF0ZVBlcmlvZBInCgRmcm9tGAEgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEiUKAnRvGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEhoKB2R1ZV9kYXkYAyABKAVCCbpIBhoEGB8oABIzCgR0eXBlGAQgASgOMhkudHlwZXMudjEuQnVzaW5lc3NEYXlUeXBlQgq6SAeCAQQQASAAKqUCCg9CdXNpbmVzc0RheVR5cGUSIQodQlVTSU5FU1NfREFZX1RZUEVfVU5TUEVDSUZJRUQQABIiCh5CVVNJTkVTU19EQVlfVFlQRV9CVVNJTkVTU19EQVkQARI5CjVCVVNJTkVTU19EQVlfVFlQRV9TUEVDSUZJQ19EQVlfUFJFQ0VESU5HX0JVU0lORVNTX0RBWRACEjoKNkJVU0lORVNTX0RBWV9UWVBFX1NQRUNJRklDX0RBWV9TVUNDRUVESU5HX0JVU0lORVNTX0RBWRADEicKI0JVU0lORVNTX0RBWV9UWVBFX0xBU1RfQlVTSU5FU1NfREFZEAQSKwonQlVTSU5FU1NfREFZX1RZUEVfTkVYVF9OVEhfQlVTSU5FU1NfREFZEAVCngEKDGNvbS50eXBlcy52MUIJRGF0ZVByb3RvUAFaQmdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by90eXBlcy92MTt0eXBlc6ICA1RYWKoCCFR5cGVzLlYxygIIVHlwZXNcVjHiAhRUeXBlc1xWMVxHUEJNZXRhZGF0YeoCCVR5cGVzOjpWMWIGcHJvdG8z", [file_buf_validate_validate, file_google_type_date]);

/**
 * @generated from message types.v1.DatePeriod
 */
export type DatePeriod = Message<"types.v1.DatePeriod"> & {
  /**
   * @generated from field: google.type.Date from = 1;
   */
  from?: Date;

  /**
   * @generated from field: google.type.Date to = 2;
   */
  to?: Date;

  /**
   * @generated from field: int32 due_day = 3;
   */
  dueDay: number;

  /**
   * @generated from field: types.v1.BusinessDayType type = 4;
   */
  type: BusinessDayType;
};

/**
 * Describes the message types.v1.DatePeriod.
 * Use `create(DatePeriodSchema)` to create a new message.
 */
export const DatePeriodSchema: GenMessage<DatePeriod> = /*@__PURE__*/
  messageDesc(file_types_v1_date, 0);

/**
 * @generated from enum types.v1.BusinessDayType
 */
export enum BusinessDayType {
  /**
   * @generated from enum value: BUSINESS_DAY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BUSINESS_DAY_TYPE_BUSINESS_DAY = 1;
   */
  BUSINESS_DAY = 1,

  /**
   * @generated from enum value: BUSINESS_DAY_TYPE_SPECIFIC_DAY_PRECEDING_BUSINESS_DAY = 2;
   */
  SPECIFIC_DAY_PRECEDING_BUSINESS_DAY = 2,

  /**
   * @generated from enum value: BUSINESS_DAY_TYPE_SPECIFIC_DAY_SUCCEEDING_BUSINESS_DAY = 3;
   */
  SPECIFIC_DAY_SUCCEEDING_BUSINESS_DAY = 3,

  /**
   * @generated from enum value: BUSINESS_DAY_TYPE_LAST_BUSINESS_DAY = 4;
   */
  LAST_BUSINESS_DAY = 4,

  /**
   * @generated from enum value: BUSINESS_DAY_TYPE_NEXT_NTH_BUSINESS_DAY = 5;
   */
  NEXT_NTH_BUSINESS_DAY = 5,
}

/**
 * Describes the enum types.v1.BusinessDayType.
 */
export const BusinessDayTypeSchema: GenEnum<BusinessDayType> = /*@__PURE__*/
  enumDesc(file_types_v1_date, 0);

